import { takeEvery, put } from 'redux-saga/effects';
import bulkUploadActions from '../actionTypes/bulkUploadActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { BULK_UPLOAD_URL, LATEST_UPLOAD_URL } from '../routes';

function* bulkUpload({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: BULK_UPLOAD_URL,
      method: 'POST',
      data: payload,
    },
    successAction: bulkUploadActions.bulkUploadSuccess,
    failureAction: bulkUploadActions.bulkUploadFailed,
  });
}

function* getLastUploadDetails({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: LATEST_UPLOAD_URL,
      method: 'GET',
      params: payload,
    },
    successAction: bulkUploadActions.getLastUploadDetailsSuccess,
    failureAction: bulkUploadActions.getLastUploadDetailsFailed,
  });
}

export default function* watchbulkUpload() {
  yield takeEvery(bulkUploadActions.bulkUpload, bulkUpload);

  yield takeEvery(bulkUploadActions.getLastUploadDetails, getLastUploadDetails);
}
